var _ = require('underscore');

/**
 * Renders errors list depending on json return array.
 */
export function renderError(errorArray) {
    return _.template('<ul class="message error no-margin">\
        <% _.each(errors, function(error) { %>\
            <li><%= error %></li>\
        <% }) %>\
    </ul>')({
        errors: errorArray
    });
}
